import { Field } from 'components/Form/Field/Field';
import { RadioButtons } from 'components/Radio/RadioButtons';

type Props = {
  'data-qa-id'?: string;
  id?: string;
  name: string;
  label?: string;
  description?: string;
  disabled?: boolean;
  onChange: (newValue: string) => void;
  type: 'OPTION_SINGLE';
  options: { value: string }[];
};

export function RequestedSingleOptionField({
  id,
  name,
  label,
  description,
  disabled,
  'data-qa-id': qaId,
  type,
  options,
  onChange,
}: Props) {
  if (type !== 'OPTION_SINGLE') return null;
  const subName = `${name}.${type.toLowerCase()}`;

  return (
    <Field
      name={name}
      label={label}
      description={description}
      customErrorMatch={(errors) => errors[name] || errors[subName]}
      renderInput={({ qaId: autoQaId, value, updateValue }) => (
        <RadioButtons
          data-qa-id={qaId || autoQaId}
          id={id}
          disabled={disabled}
          value={value?.option}
          buttons={options.map((o) => ({ ...o, label: o.value }))}
          onChange={(v) => {
            onChange(v as string);

            updateValue(
              v
                ? {
                    type: 'OPTION_SINGLE',
                    option: v,
                  }
                : null,
            );
          }}
        />
      )}
    />
  );
}
